import { TableName } from 'src/modules/Catalog/pages/Products/components/TableName/tableName';

const renderSku = row => <span>{row.sku?.split('|')[0] || '-'}</span>;

const SkuTableName = (
  <TableName label="SKU" tooltip="Código de identificação do Produto" />
);

const getSkuColumn = {
  name: SkuTableName,
  cell: renderSku,
  left: true,
  sortable: true,
  grow: 1,
  fontWeight: 'bold',
  fontSize: '18px',
};

export default getSkuColumn;
